import React, { useEffect, useState } from 'react';

import { Divider, Grid, Hidden, Typography } from '@material-ui/core';
import Helmet from 'react-helmet';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory } from 'react-router-dom';

import { VALIDATORS_MAP } from 'components/FormComponents/const';
import { useServerErrorActions } from 'contexts/ServerErrorContext';
import { authModel, passwordModel } from 'models';
import { ROUTES } from 'routes/constants';
import { getQueryParams, getTWithPathKey } from 'utils';
import { redirectToSignIn } from 'utils/helpers/urlHelpers';

import { AuthMessage } from '../AuthMessage/AuthMessage';

import { AuthCard, FormLink, StyledButtonComponent, TextValidator } from '../style';


function CreatePassword() {
  const [passwordReset, setPasswordReset] = useState(false);
  const [state, setState] = useState({
    [authModel.fields.password]: '',
    [authModel.fields.passwordConfirmation]: '',
    resetPasswordToken: '',
  });
  const { handleServerError } = useServerErrorActions();
  const getT = getTWithPathKey('pages.auth.createPassword');
  const history = useHistory();

  useEffect(() => {
    const resetPasswordToken = getQueryParams().reset_password_token;

    passwordModel
      .verifyPasswordReset({ resetPasswordToken })
      .then(() => {
        setState(prevState => ({ ...prevState, resetPasswordToken }));
      })
      .catch(() => {
        history.push(ROUTES.linkExpired);
      });
  }, []);

  const handlePost = () => {
    passwordModel
      .updatePassword(state)
      .then(() => {
        setPasswordReset(true);
      })
      .catch(handleServerError);
  };

  const handleChange = item =>
    setState(prevState => ({
      ...prevState,
      ...item,
    }));

  const disableResendButton = Object.values(state).some(value => !value);

  if (passwordReset) {
    return (
      <AuthMessage
        tabTitle={getT('title')}
        title={getT('successTitle')}
        buttonText={getT('successBtn')}
        onClick={redirectToSignIn}
      />
    );
  }

  return (
    <AuthCard>
      <Helmet title={getT('tabTitle')} />
      <Grid container direction="column" spacing={6}>
        <Grid item>
          <Typography variant="h2">{getT('title')}</Typography>
        </Grid>
        <Grid item>
          <ValidatorForm onSubmit={handlePost}>
            <TextValidator
              validators={[VALIDATORS_MAP.required]}
              label={getT('passwordInputLabel')}
              value={state[authModel.fields.password]}
              fieldName={authModel.fields.password}
              handleChange={handleChange}
              type="password"
            />
            <TextValidator
              validators={[VALIDATORS_MAP.required]}
              label={getT('passwordConfirmInputLabel')}
              value={state[authModel.fields.passwordConfirmation]}
              fieldName={authModel.fields.passwordConfirmation}
              handleChange={handleChange}
              type="password"
            />
            <StyledButtonComponent
              fullWidth
              color="primary"
              type="submit"
              text={getT('submitButton')}
              disabled={disableResendButton}
            />
          </ValidatorForm>
        </Grid>
        <Hidden smDown>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item style={{ textAlign: 'center' }}>
            <FormLink
              color="primary"
              variant="text"
              className="no-padding"
              text={getT('return')}
              onClick={redirectToSignIn}
            />
          </Grid>
        </Hidden>
      </Grid>
    </AuthCard>
  );
}

export default CreatePassword;
